import { Link } from '@tanstack/react-router';
import { Button } from '@sara/ui/components/button';
import { Plus } from 'lucide-react';
import { useActiveOrganization } from '../../contexts/auth';
import { InterviewTypeListContainer } from '../../contexts/interview-types';
import { PageHeader } from '../../components/page-header';

export function InterviewTypesPage() {
  const { organization } = useActiveOrganization();

  return (
    <div className="space-y-12">
      <PageHeader
        title="Templates"
        description="The prompts, output schema, and versions behind every interview your team runs."
        action={
          organization && (
            <Link to="/orgs/$orgSlug/templates/new" params={{ orgSlug: organization.slug }}>
              <Button
                variant="tinted"
                shape="pill"
                size="sm"
                className="h-8 gap-1.5 px-3 text-xs [&_svg]:size-3.5 sm:h-9 sm:px-4 sm:text-sm sm:[&_svg]:size-4"
              >
                <Plus strokeWidth={1.6} />
                New template
              </Button>
            </Link>
          )
        }
      />

      {organization && <InterviewTypeListContainer orgId={organization.id} />}
    </div>
  );
}
